/* eslint-disable */
// NIELSEN CODE START
// @ts-ignore This is external code from a partner (Nielsen)
// @ts-nocheck
export function initNielsenStaticQueue() {
  !(function (t, n) {
    t[n] = t[n] || {
      nlsQ: function (e, o, c, r, s, i) {
        return (
          (s = t.document),
          (r = s.createElement("script")),
          (r.defer = 1),
          (r.src =
            ("http:" === t.location.protocol ? "http:" : "https:") +
            "//cdn-gl.imrworldwide.com/conf/" +
            e +
            ".js#name=" +
            o +
            "&ns=" +
            n),
          (i = s.getElementsByTagName("script")[0]),
          i.parentNode.insertBefore(r, i),
          (t[n][o] = t[n][o] || {
            g: c || {},
            ggPM: function (e, c, r, s, i) {
              (t[n][o].q = t[n][o].q || []).push([e, c, r, s, i]);
            },
          }),
          t[n][o]
        );
      },
    };
  })(window, "NOLBUNDLE");
}
// NIELSEN CODE END
